import { EvaChart } from "constants/charts.enums";
import { EvaChartStates } from "types/factory";

import { DataEnum } from "models";

import { boxPlotLocks } from "./boxPlot";
import { cagrLocks } from "./cagr";
import { crossPlotLocks } from "./crossPlot";
import { cumTimeLocks } from "./cumTime";
import { declineRateLocks } from "./declineRate";
import { injectorTotalLocks } from "./injectorTotal";
import { materialBalanceTimeLocks } from "./materialBalanceTime";
import { probitLocks } from "./probit";
import { rateCumLocks } from "./rateCum";
import { rateDateLocks } from "./rateDate";
import { rateTimeLocks } from "./rateTime";
import { rigFracActivityLocks } from "./rigFracActivity";
import { stackedBarLocks } from "./stackedBar";
import { totalRateCumLocks } from "./totalRateCum";
import { totalRateDateLocks } from "./totalRateDate";
import { trendDateLocks } from "./trendDate";
import { wellContributionLocks } from "./wellContribution";
import { wellStatusLocks } from "./wellStatus";

export const LOCKS_MAP = {
  [EvaChart.RateCum]: rateCumLocks,
  [EvaChart.RecoveryPVI]: rateCumLocks,
  [EvaChart.RecoveryTime]: rateCumLocks,
  [EvaChart.RateTime]: rateTimeLocks,
  [EvaChart.CumTime]: cumTimeLocks,
  [EvaChart.RateDate]: rateDateLocks,
  [EvaChart.TotalRateDate]: totalRateDateLocks,
  [EvaChart.TotalRateCum]: totalRateCumLocks,
  [EvaChart.CrossPlot]: crossPlotLocks,
  [EvaChart.DeclineRate]: declineRateLocks,
  [EvaChart.CAGR]: cagrLocks,
  [EvaChart.StackedBar]: stackedBarLocks,
  [EvaChart.StackedBarHorizontal]: stackedBarLocks,
  [EvaChart.BoxPlot]: boxPlotLocks,
  [EvaChart.Probit]: probitLocks,
  [EvaChart.MaterialBalanceTime]: materialBalanceTimeLocks,
  [EvaChart.TrendDate]: trendDateLocks,
  [EvaChart.WellContribution]: wellContributionLocks,
  [EvaChart.InjectorTotal]: injectorTotalLocks,
  [EvaChart.RigFracActivity]: rigFracActivityLocks,
  // Well Status vs Time only. The current-status chart's translator never calls
  // createChartLocks — its value axis is the horizontal one and it ships no locks.
  [EvaChart.WellStatusOverTime]: wellStatusLocks
};

export function createChartLocks({
  type,
  states
}: {
  type: EvaChart;
  states: Partial<EvaChartStates>;
}): {
  lockedXMin: number;
  lockedXMax: number;
  lockedYMin: number;
  lockedYMax: number;
  lockedXMinType?: DataEnum;
  lockedXMaxType?: DataEnum;
  lockedYMinType?: DataEnum;
  lockedYMaxType?: DataEnum;
  lockedY2Min?: number;
  lockedY2Max?: number;
  lockedY2MinType?: DataEnum;
  lockedY2MaxType?: DataEnum;
} {
  const locks = LOCKS_MAP[type];
  if (!locks) {
    throw new Error(`Unknown chart type: ${type} to create locks`);
  }
  return locks(states);
}
